import React, { useEffect, useState } from "react";
import { Mail, } from 'lucide-react';
import { baseUrl, loadData } from "../../config/data";
import { useDispatch, useSelector } from "react-redux";
import Lang from "../../config/lang";
import ViewConfig from "../../config/viewConfig";
import { getQueryParam } from "../../config/helper";
import { Link, useLocation, useParams } from "react-router-dom";
import { setLanguage } from "../../redux/actions/language";

const DetailBlog = ({ }) => {
    const mobileView = ViewConfig();
    const { lang } = useSelector((state) => state.globalReducer);
    const [blog, setBlog] = useState(null);
    const [url, setUrl] = useState(null);

    const [blogListData, setBlogListData] = useState([]);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [id, setId] = useState(getQueryParam("id"));

    const dispatch = useDispatch();
    const { language } = useParams();

    useEffect(() => {
        if (language) {
            dispatch(setLanguage(language));
        }
    }, [language])

    const loadBlogata = async (id) => {
        loadData({
            url: `Blogs`,
            params: [{ title: 'filter', value: 'status:Published' }],
        }).then(async res => {
            if (res?.data) {
                const resData = res.data;
                const newresData = resData.filter(item => `${item.blogID}` !== id);
                setBlogListData(newresData)
            }
        })
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        setBlogListData([]);

        if (id) {
            loadData({ url: `Blogs/${id}` }).then((res) => {
                if (res?.data) {
                    setBlog(res.data);
                }
            });
            setUrl(`/${lang}/blogs/detail?id=${id}`)

            loadBlogata(id);
        }
    }, [id]);

    return (
        <>
            <div className='pt-4 pb-28 animate-fade-in mx-auto'>
                <div className='flex flex-col items-center justify-center mt-10 mx-auto w-[85%] md:w-[72%] max-w-[1180px]'>
                    <div className='flex flex-row items-center gap-4 pb-6 mr-auto cursor-pointer' id='backPage' onClick={() => window.history.back()}>
                        <svg className='w-[35px] md:w-[40px]' width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="59.4539" y="59.4539" width="58.9078" height="58.9078" rx="29.4539" transform="rotate(180 59.4539 59.4539)" stroke="#EA2427" stroke-width="1.0922" />
                            <path d="M24.4668 22.5L16.5329 30.0001L24.4668 37.5" stroke="#EA2427" stroke-width="2.68085" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M43.4668 30.5L18.4668 30.5" stroke="#EA2427" stroke-width="2.68085" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p className='pt-1 text-lg text-[#EA2427] font-semibold'>
                            Back
                        </p>
                    </div>
                    <div className='rounded-[35px] mb-4 text-sm font-normal w-full bg-white relative' data-aos="zoom-in" style={{ boxShadow: '1px 0px 6px 0px rgb(0 118 255 / 7%)' }}>
                        <div className='h-[250px] md:h-[320px] bg-slate-600 rounded-t-[35px]'>
                            {blog?.blogImage && <img src={baseUrl + '/' + blog?.blogImage} className="w-full h-full rounded-t-[35px] object-cover" />}
                        </div>

                        <div class="bg-[#E4F0FF] text-[#48494B] border-4 border-white rounded-full w-fit mx-auto -mt-[4rem] mb-[2rem] py-1.5 px-4 flex flex-row gap-4 items-center sticky top-[7rem]">
                            <p class='font-medium text-[13px] pr-1'>Share</p>
                            <div class='flex flex-row items-center gap-3'>
                                <a href={`https://mail.google.com/mail/u/0/?view=cm&fs=1&body=${window.location.origin}${url}`} target="_blank" class="share-btn">
                                    <img className="w-[16px]" src="/asset/icon/mail_grey.svg" />
                                </a>
                                <a href={`https://wa.me/send?text=${window.location.origin}${url}`} target="_blank" class="share-btn">
                                    <img className="w-[16px]" src="/asset/icon/wa_grey.svg" />
                                </a>
                                <a href={`https://www.facebook.com/sharer.php?u=${window.location.origin}${url}`} target="_blank" class="share-btn">
                                    <img className="w-[12px] h-[15px]" src="/asset/icon/facebook_grey.svg" />
                                </a>
                                <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${window.location.origin}${url}`} target="_blank" class="share-btn">
                                    <img className="w-[16px]" src="/asset/icon/linkedin_grey.svg" />
                                </a>
                            </div>
                        </div>

                        <div className='py-4 px-6 flex flex-col items-center'>
                            <div className='text-[#48494B] read-news'>
                                <div className="flex flex-row py-2 md:py-3">

                                    {blog?.blogTags && (blog?.blogTags?.split(',').map(tag => tag.trim())).map((val, idx) => (
                                        <div key={idx} className='py-1 px-2 mr-2 rounded-xl md:rounded-full bg-[#E4F0FF]'>
                                            <p className='text-[11px] md:text-xs'>{val}</p>
                                        </div>
                                    ))}
                                </div>
                                <h3 className='pt-1 pb-3 text-lg font-semibold'>{lang === 'en' ? blog?.blogTitle_en : blog?.blogTitle_id}</h3>
                                <div className='mb-28'>

                                    <div className="pt-2" dangerouslySetInnerHTML={{ __html: lang === 'en' ? blog?.blogContent_en : blog?.blogContent_id }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mt-12'>
                        <p className='text-[#48494B] text-[28px] md:text-[35px] font-medium mb-10 leading-tight'>{Lang(lang, 'more_reads')}</p>
                        <div className='flex flex-row justify-between flex-wrap gap-1' data-aos="zoom-in">
                            {blogListData?.map((obj, idx) => (
                                <Link to={`/${lang}/blogs/detail?id=${obj.blogID}`} onClick={() => setId(obj.blogID)} class='flex flex-row rounded-[20px] md:rounded-[30px] mb-4 text-left text-sm md:text-lg font-normal w-full md:w-[49%] h-[200px] md:h-[263px] bg-white' style={{ boxShadow: '1px 0px 6px 0px rgb(0 0 0 / 15%)' }}>
                                    <div class='rounded-s-[20px] md:rounded-s-[30px] bg-slate-600 w-[60%] md:w-[70%] h-full' style={{ backgroundImage: `url('${baseUrl + '/' + (obj?.blogThumbnail || obj?.blogImage)}')`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}></div>
                                    <div class='p-2 pr-4 flex flex-col items-end gap-2 justify-between w-full'>
                                        <div class='flex flex-col'>
                                            <div className="px-3 flex flex-row pt-1 pb-2 md:pt-5 gap-2">
                                                {<div className='py-1 px-2 rounded-xl md:rounded-full bg-[#E4F0FF]'>
                                                    <p className='text-[11px] md:text-xs'>{obj.blogTags?.split(',').map(tag => tag.trim())[0]}</p>
                                                </div>}
                                                {(obj.blogTags?.split(',').map(tag => tag.trim())).length > 1 &&
                                                    <div className='py-1 px-2 rounded-xl md:rounded-full bg-[#E4F0FF]'>
                                                        <p className='text-[11px] md:text-xs'>+{(obj.blogTags?.split(',').map(tag => tag.trim())).length - 1}</p>
                                                    </div>}
                                            </div>
                                            <p class='pl-3 pt-0 md:pt-2 text-[#48494B] font-medium truncate-2-lines'>{lang === 'en' ? obj?.blogTitle_en : obj?.blogTitle_id}</p>
                                            <div class='w-[95%]'>
                                                <div className='pl-3 pt-2 text-xs truncate-2-lines' dangerouslySetInnerHTML={{ __html: lang === 'en' ? obj?.blogContent_en : obj?.blogContent_id }} />
                                            </div>
                                        </div>
                                        <img className='w-[35px] md:w-[45px]' src="/asset/arrowNews.png" />
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DetailBlog;